// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuItem_root__MwSxa","before":"MenuItem_before__cFTur","after":"MenuItem_after__Z044i","content":"MenuItem_content__HLgWE","disabled":"MenuItem_disabled__YJlOn"};